export default __webpack_public_path__ + "static/media/svg.0d453f6a.svg";